// Make localization selects submit on change
document.addEventListener('DOMContentLoaded', function() {
  const localizationSelects = document.querySelectorAll('.localization-select');
  
  localizationSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      const form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });
});

